import { Heading, View } from "@instructure/ui";
import c3 from "c3";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import ChartColors from "../../utils/ChartColors";

const PreviewTemplateChart = ({ bindto, masteryResults, title }) => {
  const { t } = useTranslation();

  useEffect(() => {
    c3.generate({
      bindto: document.getElementById(bindto),
      padding: { left: 50 },
      color: { pattern: ChartColors },
      size: { height: 240 },
      data: {
        type: "bar",
        json: [
          {
            name: "Term 1",
            "Learning Outcome 1": (Math.random() * (100 - 20 + 1) + 20).toFixed(
              2
            ),
          },
          {
            name: "Term 1",
            "Learning Outcome 2": (Math.random() * (100 - 20 + 1) + 20).toFixed(
              2
            ),
          },
        ],
        keys: {
          x: "name",
          value: ["Learning Outcome 1", "Learning Outcome 2"],
        },
      },
      axis: {
        x: { type: "category" },
        y: {
          label: {
            text:
              masteryResults === "false"
                ? t("dashboard.avgAssignmentGrade")
                : t("dashboard.percentAchievedMastery"),
            position: "outer-middle",
          },
          min: 5,
          max: 100,
        },
      },
    });
  }, []);

  return (
    <View textAlign="center">
      <Heading level="h4">{title}</Heading>
      <div id={bindto} style={{ margin: "10px 0 0 0", width: "100%" }} />
    </View>
  );
};

export default PreviewTemplateChart;
